import { MessageBar, MessageBarType } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import * as React from 'react';
import { IInvoiceItemList } from '../../../Models/Invoice/IInvoiceList';
import { IInvoice} from '../../../Models/Invoice/IInvoice';
import { IStatusMessage } from '../../../Models/IStatusMessage';
import { MyInvoicesView } from './MyInvoicesView';
import * as Services from '../../../Services/Services';
import { IInvoiceApi } from '../../../Services/API/Invoice/IInvoiceApi';

interface IMyEventsProps {

}

export const MyInvoices: React.FunctionComponent<IMyEventsProps> = (props) => {
    const [invoiceItems, setInvoiceItems] = React.useState<IInvoiceItemList[]>([]);
    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()
    const [isPropertiesOpened, setIsPropertiesOpened] = useBoolean(false);
    const [selectedEvent, setSelectedEvent] = React.useState<IInvoice>()


    const selectItem = (id: number) => {

    }

    const loadData = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const invoiceApi = Services.ServicesProvider.GetService<IInvoiceApi>(Services.InvoiceApi);
        const invoices = await invoiceApi.getInvoicesByUserId();

        if (invoices.isSuccess && invoices.data) {
            setStatusMessage({ message: invoices.message, type: MessageBarType.success });
            setInvoiceItems(invoices.data);
        }
        else {
            setStatusMessage({ message: invoices.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    React.useEffect(() => {
        loadData();
    },[])

    return (<>
        <MyInvoicesView selectItem={selectItem} isLoading={isLoading} items={invoiceItems} statusMessage={statusMessage} />
        {statusMessage && statusMessage.message ? <MessageBar messageBarType={statusMessage.type}>{statusMessage.message}</MessageBar> : null}

    </>)

}
